<template>
  <div class="product-widget" v-if="requestList.length > 0">
    <div class="product-widget-header">
      <h3>Prodotti Selezionati ({{ requestList.length }})</h3>
      <h3>Quantità</h3>
    </div>

    <div
      class="request-item"
      v-for="(item, index) in requestList"
      :key="item.uid"
      :class="{ 'is-first': index === 0 }"
    >
      <div class="item-name">
        {{ item.name }}
        <span v-if="item.code" class="item-code"> — COD. {{ item.code }}</span>
      </div>

      <div class="item-quantity">{{ item.quantity }}</div>

      <div class="item-buttons">
        <button
          type="button"
          class=""
          data-type="plus"
          @click="changeQuantity(item.uid, $event)"
        >
          +
        </button>

        <button
          type="button"
          class="btn btn-outline-primary"
          data-type="minus"
          @click="changeQuantity(item.uid, $event)"
        >
          -
        </button>
        <button @click="removeFromRequest(item.uid)">x</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useToast } from "vue-toastification";
import ToastLink from "./ToastLink.vue"; // importa il componente

const toast = useToast(); //per i messaggi toast

const STORAGE_KEY = "productRequestData";
const hiddenInputForm = document.getElementById("request-list_product");

//localStorage.clear();

// Leggi i dati da localStorage
const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? {};

const requestList = ref(saved.requestList ?? []);
//const userName = ref("");
//const userEmail = ref("");

// Metodi
/**
 * requestList è un ref (Vue 3). Per accedere all’array vero usi .value. L’array è reattivo grazie a Vue: modifiche (push, splice, modifica proprietà) aggiornano il DOM.
 *	2.	requestList.value.find((item) => item.id === product.id)
 *	  •	Cerca nel carrello un elemento già presente con lo stesso id.
 *	  •	find restituisce il primo elemento che soddisfa la condizione oppure undefined se non trovato.
 *	  •	Attenzione ai tipi: se product.id è stringa (proveniente da data-*) e item.id è numero, la comparazione === fallirà. Meglio assicurarsi che gli id abbiano lo stesso tipo (es. parseInt prima).
 *  3.	const existing = ...
 *	  •	existing è una riferimento all’oggetto presente nell’array (non è una copia).
 *  	•	Se esiste, manipolare existing equivale a manipolare l’elemento nella requestList.value.
 *  4.	if (existing) { existing.quantity++; }
 *    •	Se il prodotto è già nel carrello, aumenta la sua quantity di 1.
 *    •	Poiché stai mutando una proprietà di un oggetto che è dentro un array reattivo, Vue rileva il cambiamento e aggiorna la UI (es. v-model sugli input rifletterà la nuova quantità).
 *  5.	else { requestList.value.push({ ...product, quantity: 1 }); }
 *	  •	Se il prodotto non è presente, si inserisce una copia dell’oggetto product con la proprietà quantity: 1.
 *    •	Lo spread operator { ...product, quantity: 1 } evita di mutare l’oggetto product originale (buona pratica se product proviene da un’altra fonte o sarà riutilizzato altrove).
 * @param product
 */
function addToRequest(product) {
  const existing = requestList.value.find(
    (item) => item.id === product.id && item.code === product.code
  );
  if (existing) {
    existing.quantity += product.quantity ?? 1;
    // Mostra toast
    toast(
      {
        component: ToastLink,
        props: {
          productName: product.name,
          //anchorLink: "#list", // ancora interna
        },
      },
      {
        type: "warning",
      }
    );
  } else {
    requestList.value.push({ ...product, quantity: product.quantity ?? 1, uid: Date.now() + '-' + Math.random() });
    // Mostra toast success
    toast(
      {
        component: ToastLink,
        props: {
          productName: product.name,
          //anchorLink: "#list", // ancora interna
        },
      },
      {
        type: "success",
      }
    );
    //fine
  }
}

// Rimuove un elemento dalla lista
function removeFromRequest(uid) {
  const element = requestList.value.find((item) => item.uid === uid);
  if (element) {
    requestList.value = requestList.value.filter((item) => item.uid !== uid);
    toast.success(`${element.name} rimosso dalla lista!`);
  }
}

//cambia la quantità
function changeQuantity(uid, event) {
  const type = event.currentTarget.dataset.type;
  const product = requestList.value.find((item) => item.uid === uid);

  if (!product) return;

  if (type === "plus") {
    product.quantity++;
  } else if (type === "minus" && product.quantity > 1) {
    product.quantity--;
  }
}

// 🔹 Salvataggio automatico ogni volta che cambia la lista o i dati del form
watch(
  [requestList /*userName, userEmail*/], // array di variabili reattive (ref) da osservare
  () => {
    //Creiamo un oggetto con lo stato corrente del widget
    const data = {
      requestList: requestList.value, // array dei prodotti selezionati
      //userName: userName.value,
      //userEmail: userEmail.value,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); // converto in json e salvo in localStorage

    //Se esiste il campo hidden del form lo popolo
    if (hiddenInputForm) {
      hiddenInputForm.value = JSON.stringify(requestList.value);
    }
  },
  //Opzioni del watcher
  { deep: true }
  // deep:true serve perché requestList è un array di oggetti:
  // Vue deve "osservare in profondità" anche le modifiche interne,
  // come quando cambia item.quantity o si aggiunge/rimuove un prodotto.
);

// Codice variante selezionata
const selectedVarCode = ref(null);

// Collego pulsanti PHP
onMounted(() => {
  // sincronizzazione iniziale
  if (hiddenInputForm && requestList.value.length > 0) {
    hiddenInputForm.value = JSON.stringify(requestList.value);
  }

  // Listener sulle varianti: salva il codice selezionato
  document.querySelectorAll(".single-variant").forEach((variant) => {
    variant.addEventListener("click", () => {
      document.querySelectorAll(".single-variant").forEach((v) => v.classList.remove("variant-selected"));
      variant.classList.add("variant-selected");
      selectedVarCode.value = variant.dataset.varcode || null;
    });
  });

  // Pulsanti +/-
  document.querySelectorAll(".qty-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const input = btn.closest(".qty-selector").querySelector(".qty-input");
      let val = parseInt(input.value) || 1;
      if (btn.classList.contains("qty-plus")) val++;
      else if (btn.classList.contains("qty-minus") && val > 1) val--;
      input.value = val;
    });
  });

  document.querySelectorAll(".add-to-request").forEach((btn) => {
    btn.addEventListener("click", () => {
      const qtyInput = btn.closest(".product-quote-actions")?.querySelector(".qty-input");
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      const code = selectedVarCode.value || btn.dataset.code || null;
      const product = {
        id: parseInt(btn.dataset.id),
        name: btn.dataset.name,
        code: code,
        quantity: qty,
      };
      addToRequest(product);
    });
  });
});
</script>
